import { watch } from 'vue';
import { Router } from 'vue-router';

/**
 * Composable pour le tracking Matomo automatique des pages
 */
export function useMatomoTracking(router: Router) {
  // Track page view on route change
  router.afterEach((to) => {
    if (typeof window !== 'undefined' && window._paq) {
      // Set custom URL
      window._paq.push(['setCustomUrl', to.fullPath]);

      // Set document title
      const pageTitle = to.meta.title || to.name || 'Page';
      window._paq.push(['setDocumentTitle', pageTitle as string]);

      // Track the page view
      window._paq.push(['trackPageView']);
    }
  });
}

/**
 * Track a custom event in Matomo
 */
export function trackEvent(category: string, action: string, name?: string, value?: number) {
  if (typeof window !== 'undefined' && window._paq) {
    window._paq.push(['trackEvent', category, action, name, value]);
  }
}

/**
 * Track a custom goal in Matomo
 */
export function trackGoal(goalId: number, customRevenue?: number) {
  if (typeof window !== 'undefined' && window._paq) {
    window._paq.push(['trackGoal', goalId, customRevenue]);
  }
}
